"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BurgerMenuIconWrapper = exports.BurgerMenuIconRoot = exports.BurgerMenuIconLine = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _styles = require("../../styles");
const BurgerMenuIconRoot = exports.BurgerMenuIconRoot = (0, _mui.styled)(_mui.ButtonBase, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['isOpen'])
})(({
  isOpen,
  theme
}) => ({
  color: theme.palette.text.primary,
  fontSize: '2.8rem',
  height: 24,
  width: 24,
  [theme.breakpoints.up('md')]: {
    height: 32,
    width: 32,
    ...(0, _styles.focusableStyle)(theme),
    '&:hover': {
      '.burgerMenuIconLine': {
        boxShadow: _mui.SHADOW_LEVEL1
      }
    },
    ...(isOpen && {
      '&:hover': {
        '.burgerMenuIconLine': {
          boxShadow: _mui.SHADOW_LEVEL1
        }
      }
    })
  }
}));
const BurgerMenuIconWrapper = exports.BurgerMenuIconWrapper = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isMobile,
  theme
}) => ({
  display: 'none',
  ...(isMobile && {
    display: 'block'
  }),
  [theme.breakpoints.up('md')]: {
    display: 'block',
    ...(isMobile && {
      display: 'none'
    })
  }
}));
const BurgerMenuIconLine = exports.BurgerMenuIconLine = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isOpen,
  isMobile,
  theme
}) => ({
  backgroundColor: theme.palette.text.primary,
  height: 1,
  marginBottom: 6,
  opacity: 1,
  position: 'relative',
  transform: 'translateX(0) rotate(0) translateY(0)',
  transition: 'opacity 0.3s linear, transform 0.3s linear',
  width: 15,
  ...(isMobile && {
    display: 'block'
  }),
  [theme.breakpoints.up('md')]: {
    marginBottom: 8,
    width: 20,
    ...(isOpen && {
      '&:nth-of-type(1)': {
        transform: 'rotate(45deg) translateY(9px) translateX(4px)'
      },
      '&:nth-of-type(2)': {
        opacity: 0,
        transform: 'translateX(22px)'
      },
      '&:nth-of-type(3)': {
        transform: 'rotate(-45deg) translateY(-9px) translateX(4px);'
      }
    })
  },
  '&:nth-of-type(3)': {
    marginBottom: 0
  }
}));